import React from "react";

export default props => (
<div className="test-page-content-inner test-page-test-finished">
    <div className="header">
        <i className="far fa-check"></i>
        <h1>Congratulations!</h1>
    </div>
    <p>You have completed the {props.testName} test.</p>
    <p>Take a short break now if you need to.</p>
    <p>Click on the NEXT button when you are ready to proceed to your next test.</p>
</div>
);
